import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type RepresentativeItem = {
  id: number;
  first_name: string;
  last_name: string;
  email?: string;
  phone_code?: string;
  phone_number?: string;
  // Returned by the API but not editable through the representative form.
  job_title?: string;
  picture?: string | false;
  status: number;
  role_id?: number;
  role_text?: string;
};

interface RepresentativesState {
  items: RepresentativeItem[];
  loading: boolean;
  error: string | null;
}

const initialState: RepresentativesState = {
  items: [],
  loading: true,
  error: null,
};

const representativesSlice = createSlice({
  name: 'representatives',
  initialState,
  reducers: {
    setRepresentatives: (state, action: PayloadAction<RepresentativeItem[]>) => {
      state.items = action.payload;
    },
    addRepresentative: (state, action: PayloadAction<RepresentativeItem>) => {
      state.items.unshift(action.payload);
    },
    updateRepresentative: (state, action: PayloadAction<RepresentativeItem>) => {
      const index = state.items.findIndex((item) => item.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = { ...state.items[index], ...action.payload };
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setRepresentatives, addRepresentative, updateRepresentative, setLoading, setError } = representativesSlice.actions;
export default representativesSlice.reducer;
